import * as React from "../../_snowpack/pkg/react.js";
const DataCell = ({
  content,
  className = "",
  leftAlign = false
}) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: (leftAlign ? "text-left" : "text-center") + ` flex items-center border border-collapse p-2 ${className} h-16`
  }, `${content === 0 ? "-" : content}`);
};
export default DataCell;
